import { render, staticRenderFns } from "./ExpandRemotesButton.vue?vue&type=template&id=f695925c&scoped=true&"
import script from "./ExpandRemotesButton.vue?vue&type=script&lang=js&"
export * from "./ExpandRemotesButton.vue?vue&type=script&lang=js&"
import style0 from "./ExpandRemotesButton.vue?vue&type=style&index=0&id=f695925c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f695925c",
  null
  
)

export default component.exports